
export const cognitive = {
  intro: {
    title: 'Evaluación Cognitiva',
    subtitle: 'Mida su capacidad cognitiva a través del razonamiento verbal, numérico y abstracto.',
    duration: '{{timeLimit}} minutos · 50 preguntas',
    areas: 'Razonamiento verbal, numérico y abstracto',
    beforeYouBegin: 'Antes de comenzar',
    instruction1: 'Encuentre un ambiente tranquilo sin distracciones',
    instruction2: 'Asegúrese de tener {{timeLimit}} minutos ininterrumpidos',
    instruction3: 'El cronómetro no se puede pausar una vez iniciado',
    instruction4: 'Trabaje rápido pero con precisión — sin penalización por respuestas incorrectas',
    startAssessment: 'Iniciar Evaluación',
    backToHome: 'Volver a la página principal',
    aiWarningTitle: 'Aviso de Integridad Académica',
    aiWarningText: 'El uso de herramientas de IA, asistencia externa o cualquier recurso no autorizado está estrictamente prohibido. Nuestro sistema monitorea activamente patrones irregulares. Los candidatos que utilicen IA o ayuda externa serán inmediatamente descalificados.'
  },
  loading: {
    title: 'Cargando Evaluación...',
    message: 'Por favor espere mientras preparamos su evaluación cognitiva.'
  },
  error: {
    title: 'Error de Evaluación',
    message: 'Hubo un problema al cargar las preguntas. Inténtelo de nuevo.',
    retry: 'Reintentar Evaluación',
    indexTitle: 'Error de Índice de Pregunta',
    indexMessage: 'La pregunta está fuera de rango. Reinicie la evaluación.',
    questionTitle: 'Error de Pregunta',
    questionMessage: 'Hubo un problema con esta pregunta. Inténtelo de nuevo.',
    restart: 'Reiniciar Evaluación'
  },
  test: {
    questionCounter: 'Pregunta',
    of: 'de',
    reasoning: 'Razonamiento'
  },
  types: {
    verbal: 'Verbal',
    numerical: 'Numérico',
    abstract: 'Abstracto'
  },
  results: {
    title: 'Sus Resultados de Evaluación Cognitiva',
    subtitle: 'Análisis integral de sus habilidades cognitivas',
    yourStrengths: 'Sus Fortalezas Cognitivas',
    strongestArea: 'Su área cognitiva más fuerte',
    percentile: 'º percentil',
    performance: 'Resumen de Rendimiento',
    questionsCompleted: 'Preguntas Completadas',
    correctResponses: 'Respuestas Correctas',
    successRate: 'Tasa de Éxito',
    timeManagement: 'Gestión del Tiempo',
    remaining: 'restante',
    growthOpportunities: 'Oportunidades de Crecimiento',
    understanding: 'Entendiendo Sus Resultados',
    profileDesc: 'Su perfil cognitivo muestra cómo procesa diferentes tipos de información y resuelve problemas en tres áreas clave.',
    verbalReasoning: 'Razonamiento Verbal',
    verbalDesc: 'Su capacidad para entender, analizar y trabajar con información escrita y conceptos de lenguaje.',
    numericalReasoning: 'Razonamiento Numérico',
    numericalDesc: 'Su capacidad para trabajar con números, conceptos matemáticos y relaciones cuantitativas.',
    abstractReasoning: 'Razonamiento Abstracto',
    abstractDesc: 'Su habilidad para identificar patrones, relaciones lógicas y resolver problemas nuevos.',
    reminder: 'Recuerde: Las habilidades cognitivas pueden desarrollarse a través de la práctica y el aprendizaje.',
    practiceTip: 'Practique Regularmente',
    practiceDesc: 'Los ejercicios mentales regulares y los rompecabezas desafiantes pueden ayudar a mejorar el rendimiento cognitivo.',
    learningPath: 'Aprendizaje Enfocado',
    learningDesc: 'Dirija sus áreas más débiles con programas de entrenamiento específicos y recursos educativos.',
    nextSteps: 'Próximos Pasos',
    nextStepsDesc: 'Considere volver a tomar la evaluación después de práctica enfocada para seguir su progreso.'
  },
  performance: {
    outstanding: 'Rendimiento Excepcional',
    strong: 'Rendimiento Fuerte',
    good: 'Buen Rendimiento',
    developing: 'Rendimiento en Desarrollo',
    growing: 'Rendimiento en Crecimiento',
    learning: 'Rendimiento en Aprendizaje'
  },
  message: {
    outstanding: '¡Habilidades cognitivas excepcionales! Demuestra habilidades de razonamiento superiores en múltiples dominios.',
    strong: '¡Rendimiento cognitivo fuerte! Muestra habilidades de razonamiento bien desarrolladas con espacio para crecimiento continuo.',
    good: '¡Habilidades cognitivas sólidas! Demuestra buenas habilidades de razonamiento con potencial para desarrollo adicional.',
    developing: 'Sus habilidades cognitivas se están desarrollando bien. Con práctica enfocada, puede fortalecer sus habilidades de razonamiento.',
    growing: 'Muestra promesa en el razonamiento cognitivo. El aprendizaje y la práctica continuos le ayudarán a mejorar.',
    learning: 'Cada evaluación es una oportunidad de aprendizaje. Enfóquese en desarrollar sus habilidades cognitivas paso a paso.'
  },
  thankYou: {
    title: '¡Evaluación Completada!',
    message: 'Gracias por completar la evaluación.',
    backToHome: 'Volver al Inicio'
  },
  questions: {
    verbal: {
      q1: {
        question: '¿Qué palabra completa mejor esta analogía: LIBRO es a leer como CANCIÓN es a ____?',
        optionA: 'Escribir',
        optionB: 'Escuchar',
        optionC: 'Bailar',
        optionD: 'Cantar'
      },
      q2: {
        question: '¿Cuál es el antónimo de "ABURRIDO"?',
        optionA: 'Tedioso',
        optionB: 'Divertido',
        optionC: 'Monótono',
        optionD: 'Serio'
      },
      q3: {
        question: '¿Qué palabra NO pertenece al grupo?',
        optionA: 'Eufórico',
        optionB: 'Jubiloso',
        optionC: 'Extasiado',
        optionD: 'Melancólico'
      },
      q4: {
        question: '"FLUIDO" es a hablar como "ÁGIL" es a ____',
        optionA: 'Pensar',
        optionB: 'Moverse',
        optionC: 'Escribir',
        optionD: 'Cantar'
      },
      q5: {
        question: '¿Qué palabra es más cercana en significado a "PLAUSIBLE"?',
        optionA: 'Imposible',
        optionB: 'Creíble',
        optionC: 'Extraño',
        optionD: 'Seguro'
      },
      q6: {
        question: '¿Qué palabra describe mejor a alguien que es "PRAGMÁTICO"?',
        optionA: 'Teórico',
        optionB: 'Práctico',
        optionC: 'Emocional',
        optionD: 'Artístico'
      },
      q7: {
        question: '¿Cuál es el significado de "PASAJERO"?',
        optionA: 'Eterno',
        optionB: 'Que no es duradero',
        optionC: 'Rápido',
        optionD: 'Moderno'
      },
      q8: {
        question: '¿Qué palabra es más similar a "TENAZ"?',
        optionA: 'Débil',
        optionB: 'Persistente',
        optionC: 'Rápido',
        optionD: 'Gentil'
      },
      q9: {
        question: '¿Qué significa "INGENUO"?',
        optionA: 'Inteligente',
        optionB: 'Rápido',
        optionC: 'Inocente / Sin malicia',
        optionD: 'Atrevido'
      },
      q10: {
        question: '"SOFISTICADO" es a simple como "COMPLEJO" es a ____',
        optionA: 'Difícil',
        optionB: 'Enredado',
        optionC: 'Sencillo',
        optionD: 'Avanzado'
      },
      q11: {
        question: '¿Cuál es el significado de "OMNIPRESENTE"?',
        optionA: 'Ausente',
        optionB: 'Que está en todas partes',
        optionC: 'Muy pequeño',
        optionD: 'Antiguo'
      },
      q12: {
        question: '¿Cuál es el sinónimo más preciso de "PERSPICAZ"?',
        optionA: 'Confundido',
        optionB: 'Ingenioso',
        optionC: 'Ruidoso',
        optionD: 'Misterioso'
      },
      q13: {
        question: '"INDÍGENA" es a nativo como "AJENO" es a ____',
        optionA: 'Extraño',
        optionB: 'Propio',
        optionC: 'Lejano',
        optionD: 'Perteneciente'
      },
      q14: {
        question: 'En un argumento lógico, si todas las rosas son flores y todas las flores necesitan agua, ¿qué podemos concluir sobre las rosas?',
        optionA: 'Son hermosas',
        optionB: 'Necesitan agua',
        optionC: 'Son rojas',
        optionD: 'Tienen espinas'
      },
      q15: {
        question: '¿Qué palabra es más similar en significado a "ENIGMA"?',
        optionA: 'Solución',
        optionB: 'Rompecabezas',
        optionC: 'Respuesta',
        optionD: 'Declaración'
      },
      q16: {
        question: '¿Cuál es el sinónimo de "CLANDESTINO"?',
        optionA: 'Público',
        optionB: 'Secreto',
        optionC: 'Ruidoso',
        optionD: 'Legal'
      },
      q17: {
        question: '"ABSOLVER" es a "PERDONAR" como "REPRENDER" es a ____',
        optionA: 'Elogiar',
        optionB: 'Regañar',
        optionC: 'Ignorar',
        optionD: 'Premiar'
      }
    },
    numerical: {
      q18: {
        question: 'Si un producto cuesta $80 y tiene un descuento del 25%, ¿cuál es el nuevo precio?',
        optionA: '$55',
        optionB: '$60',
        optionC: '$65',
        optionD: '$70'
      },
      q19: {
        question: '¿Qué sigue en esta secuencia: 2, 6, 18, 54, ?',
        optionA: '108',
        optionB: '162',
        optionC: '216',
        optionD: '270'
      },
      q20: {
        question: 'Si 3x + 7 = 22, ¿cuál es x?',
        optionA: '3',
        optionB: '4',
        optionC: '5',
        optionD: '6'
      },
      q21: {
        question: '¿Cuál es el siguiente número: 1, 4, 9, 16, 25, ?',
        optionA: '30',
        optionB: '32',
        optionC: '36',
        optionD: '40'
      },
      q22: {
        question: 'Si el 40% de un número es 60, ¿cuál es el número?',
        optionA: '120',
        optionB: '140',
        optionC: '150',
        optionD: '160'
      },
      q23: {
        question: '¿Cuánto es el 25% de 80 más el 30% de 60?',
        optionA: '35',
        optionB: '38',
        optionC: '41',
        optionD: '44'
      },
      q24: {
        question: 'Si y = 2x + 3 y x = 4, ¿cuánto es y?',
        optionA: '9',
        optionB: '10',
        optionC: '11',
        optionD: '12'
      },
      q25: {
        question: '¿Cuál es el patrón: 2, 5, 11, 23, ?',
        optionA: '41',
        optionB: '45',
        optionC: '47',
        optionD: '51'
      },
      q26: {
        question: 'Si una caja contiene 24 artículos y quitas 1/3, ¿cuántos quedan?',
        optionA: '14',
        optionB: '16',
        optionC: '18',
        optionD: '20'
      },
      q27: {
        question: '¿Cuál es el siguiente número en esta secuencia: 1, 8, 27, 64, ?',
        optionA: '100',
        optionB: '125',
        optionC: '144',
        optionD: '169'
      },
      q28: {
        question: 'Si 2x - 5 = 3x + 7, ¿cuál es x?',
        optionA: '-12',
        optionB: '-10',
        optionC: '-8',
        optionD: '-6'
      },
      q29: {
        question: 'Una secuencia sigue la regla: cada término es el doble del anterior más 1. Si el primer término es 3, ¿cuál es el cuarto término?',
        optionA: '15',
        optionB: '21',
        optionC: '31',
        optionD: '35'
      },
      q30: {
        question: '¿Qué porcentaje es 45 de 180?',
        optionA: '20%',
        optionB: '25%',
        optionC: '30%',
        optionD: '35%'
      },
      q31: {
        question: 'Si el promedio de 5 números es 12, y 4 de ellos son 8, 10, 14 y 16, ¿cuál es el quinto número?',
        optionA: '10',
        optionB: '12',
        optionC: '14',
        optionD: '16'
      },
      q32: {
        question: 'Un carro recorre 240 km en 3 horas, luego 160 km en 2 horas. ¿Cuál es la velocidad promedio de todo el viaje?',
        optionA: '75 km/h',
        optionB: '80 km/h',
        optionC: '85 km/h',
        optionD: '90 km/h'
      },
      q33: {
        question: 'Si 3/4 de un número es igual a 2/3 de 90, ¿cuál es el número?',
        optionA: '72',
        optionB: '75',
        optionC: '80',
        optionD: '85'
      },
      q34: {
        question: '¿Cuál es el siguiente término en la secuencia: 3, 7, 15, 31, ?',
        optionA: '59',
        optionB: '63',
        optionC: '67',
        optionD: '71'
      }
    },
    abstract: {
      q35: {
        question: 'Complete el patrón: A1B2C3D4?',
        optionA: 'E5',
        optionB: 'F6',
        optionC: 'E4',
        optionD: 'D5'
      },
      q36: {
        question: '¿Cuál forma es la diferente: Círculo, Cuadrado, Triángulo, Rectángulo?',
        optionA: 'Círculo',
        optionB: 'Cuadrado',
        optionC: 'Triángulo',
        optionD: 'Rectángulo'
      },
      q37: {
        question: '¿Qué sigue: 1, 1, 2, 3, 5, 8, ?',
        optionA: '11',
        optionB: '12',
        optionC: '13',
        optionD: '14'
      },
      q38: {
        question: 'Si ★ representa 4 y ♦ representa 7, ¿cuánto es ★ × ♦?',
        optionA: '24',
        optionB: '26',
        optionC: '28',
        optionD: '30'
      },
      q39: {
        question: '¿Qué número completa el patrón: 2, 4, 8, 16, ?',
        optionA: '24',
        optionB: '28',
        optionC: '32',
        optionD: '36'
      },
      q40: {
        question: '¿Qué patrón continúa: XYZ, WXY, VWX, ?',
        optionA: 'UVW',
        optionB: 'VWX',
        optionC: 'TUV',
        optionD: 'UVX'
      },
      q41: {
        question: 'Complete la secuencia: 100, 81, 64, 49, ?',
        optionA: '36',
        optionB: '35',
        optionC: '34',
        optionD: '33'
      },
      q42: {
        question: '¿Cuál sigue: ◐◑◒◓?',
        optionA: '◐',
        optionB: '◑',
        optionC: '◒',
        optionD: '◓'
      },
      q43: {
        question: 'Si los patrones se repiten cada 3: ABCABCABC, ¿cuál es el 10º elemento?',
        optionA: 'A',
        optionB: 'B',
        optionC: 'C',
        optionD: 'D'
      },
      q44: {
        question: 'Complete: 1A, 3B, 5C, 7D, ?',
        optionA: '8E',
        optionB: '9E',
        optionC: '9F',
        optionD: '10E'
      },
      q45: {
        question: '¿Qué elemento rompe el patrón: AEIOUA?',
        optionA: 'A',
        optionB: 'E',
        optionC: 'I',
        optionD: 'U'
      },
      q46: {
        question: '¿Cuál es el siguiente número en: 2, 6, 12, 20, 30, ?',
        optionA: '40',
        optionB: '42',
        optionC: '44',
        optionD: '46'
      },
      q47: {
        question: 'Complete la secuencia lógica: Z1A, Y2B, X3C, ?',
        optionA: 'W4D',
        optionB: 'V4D',
        optionC: 'W5D',
        optionD: 'V5E'
      },
      q48: {
        question: 'Si los símbolos siguen un patrón: ♠=1, ♥=4, ♦=9, ♣=16, ¿cuánto vale ★?',
        optionA: '20',
        optionB: '25',
        optionC: '30',
        optionD: '36'
      },
      q49: {
        question: '¿Qué sigue en el patrón matricial: [1,2][3,4], [2,3][4,5], [3,4][5,6], ?',
        optionA: '[4,5][6,7]',
        optionB: '[4,6][6,8]',
        optionC: '[5,6][7,8]',
        optionD: '[3,5][5,7]'
      },
      q50: {
        question: 'Complete la transformación: ABC→BCD, DEF→EFG, HIJ→?',
        optionA: 'IJK',
        optionB: 'JKL',
        optionC: 'HIK',
        optionD: 'HJK'
      }
    }
  }
};
